import ResetPassword from './components/ResetPassword.vue';
import Register from './components/Register.vue';
import Login from './components/Login.vue';

export default {
  components: {
    ResetPassword,
    Register,
    Login
  },

  computed: {
    user() {
      return this.$store.state.auth.user;
    }
  },

  data() {
    return {
      tab: 'signin'
    }
  },

  methods: {
    onReturn(tab){
      this.tab = tab;
    }
  }
}